exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-da4b89d2] {\n  font-weight: 800;\n  color: black;\n}\n.position[data-v-da4b89d2] {\n  position: absolute;\n  right: 10px;\n  top: 46px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-da4b89d2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/stnboxtype/stnboxtype.component.scss
// module id = 853
// module chunks = 0